import { Link } from 'react-router-dom';
import type { Film } from '@/types/film';
import { typeLabel } from '@/mocks/categories';
import { viewCountLabel } from '@/lib/catalog';

interface FilmCardProps {
  film: Film;
  index?: number;
}

export default function FilmCard({ film, index = 0 }: FilmCardProps) {
  return (
    <Link
      to={`/detail/${film.id}`}
      className="group block"
      style={{ animationDelay: `${Math.min(index, 8) * 45}ms` }}
    >
      <div className="relative w-full aspect-[2/3] rounded-lg overflow-hidden bg-background-200 animate-fade-up">
        <img
          src={film.poster}
          alt={`${film.title} 影视封面`}
          title={`${film.title} ${film.genre} ${film.year} 在线观看`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-primary-950/85 via-primary-950/10 to-transparent opacity-90" />
        <div className="absolute top-2 left-2 flex items-center gap-1">
          <span className="px-1.5 py-0.5 rounded-md bg-background-50/90 text-[10px] font-semibold text-primary-700">
            HD
          </span>
          <span className="px-1.5 py-0.5 rounded-md bg-accent-500 text-[10px] font-semibold text-primary-950">
            {film.rating.toFixed(1)}
          </span>
        </div>
        <div className="absolute inset-x-0 bottom-0 p-3">
          <span className="text-[10px] text-background-200/90">{typeLabel(film.type)} · {film.genre}</span>
          <p className="mt-1 text-xs text-background-50/80 flex items-center gap-1">
            <i className="ri-eye-line text-[11px]" />
            {viewCountLabel(film.views)}
          </p>
        </div>
        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <span className="w-11 h-11 rounded-full bg-accent-500 text-primary-950 flex items-center justify-center">
            <i className="ri-play-fill text-xl" />
          </span>
        </div>
      </div>
      <div className="mt-3">
        <h3 className="text-sm font-semibold text-foreground-950 truncate group-hover:text-primary-600 transition-colors">
          {film.title}
        </h3>
        <p className="mt-1 text-xs text-foreground-500 flex items-center gap-1.5 whitespace-nowrap overflow-hidden">
          <span>{film.year}</span>
          <span className="w-0.5 h-0.5 rounded-full bg-foreground-300" />
          <span>{film.region}</span>
          <span className="w-0.5 h-0.5 rounded-full bg-foreground-300" />
          <span className="truncate">{film.episodes}</span>
        </p>
        <p className="mt-1.5 text-xs leading-5 text-foreground-600 line-clamp-2-safe">{film.summary}</p>
      </div>
    </Link>
  );
}